import { DatatableRowData, isRawRow, SectionData } from "@/domain/view/components/datatable/datatable-types";
import { useDatatableContext } from "@/domain/view/components/datatable/use-datatable-context";
import { Row } from "@tanstack/react-table";

import { User } from "../../models/user-model";
import { UserViewOptional } from "../user-view-optional";

export interface DatatableAssigneeSectionHeaderProps<TData extends DatatableRowData> {
  data: SectionData<TData>;
  currentRow: Row<SectionData<TData>>;
  user?: User | null;
}

export const DatatableAssigneeSectionHeader = <TData extends DatatableRowData>({
  data,
  user,
}: DatatableAssigneeSectionHeaderProps<TData>) => {
  const { table } = useDatatableContext<TData>();

  const rowModel = table.getFilteredRowModel();
  const filteredRows = rowModel.flatRows.filter((row) => {
    if (!isRawRow(row.original)) {
      return false;
    }
    return data.key === data.getSectionKey(row.original);
  });
  const count = filteredRows.length;

  return (
    <div className="flex h-full flex-row items-center justify-between gap-2 bg-foreground/3 px-2">
      <div className="flex flex-row items-center justify-start gap-2">
        <UserViewOptional user={user} logoOnly={false} className="h-3.5 w-3.5" />
        <span className="text-xs text-muted-foreground">{count}</span>
      </div>
      <div className="flex flex-row items-center justify-end"></div>
    </div>
  );
};
